/* eslint-disable max-lines */
const INTEGRATION_TYPES = Object.freeze({
  YARDI: "YARDI",
  BLUEMOON: "BLUEMOON",
  ENTRATA: "ENTRATA",
  REAL_PAGE: "REAL-PAGE",
  RENT_MANAGER: "RENT-MANAGER",
});

export enum IntegrationProvider {
  yardi = "yardi",
  bluemoon = "bluemoon",
  entrata = "entrata",
  realPage = "real-page",
  rentManager = "rent-manager",
  cosign = "cosign",
}

const YARDI_SECURITY_DEPOSIT_PREFERENCES = Object.freeze({
  RENT: "Rent",
  VERO: "VERO",
  YARDI: "YARDI",
});

const PERSONA_VERIFICATION_TYPES = Object.freeze({
  DATABASE: "verification/database",
  PHONE_2FA: "verification/phone-number",
  GOVERNMENT_ID: "verification/government-id",
  SELFIE: "verification/selfie",
  DOCUMENT: "verification/document",
  AAMVA: "verification/aamva",
});

const PERSONA_VERIFICATION_TYPES_LABELS = Object.freeze({
  [PERSONA_VERIFICATION_TYPES.DATABASE]: "Database",
  [PERSONA_VERIFICATION_TYPES.PHONE_2FA]: "Phone number",
  [PERSONA_VERIFICATION_TYPES.GOVERNMENT_ID]: "Government ID",
  [PERSONA_VERIFICATION_TYPES.SELFIE]: "Selfie",
  [PERSONA_VERIFICATION_TYPES.DOCUMENT]: "Document",
  [PERSONA_VERIFICATION_TYPES.AAMVA]: "AAMVA",
});

const PERSONA_VERIFICATION_PREFIXES = {
  [PERSONA_VERIFICATION_TYPES.GOVERNMENT_ID]: "id_",
  [PERSONA_VERIFICATION_TYPES.SELFIE]: "selfie_",
  [PERSONA_VERIFICATION_TYPES.DATABASE]: "database_",
  [PERSONA_VERIFICATION_TYPES.AAMVA]: "aamva_",
};

// This constants represents "persona_inquiry_status" property returned by the API
// it should be renamed in the future to PERSONA_INQUIRY_VERIFICATION_STATUS
const PERSONA_VERIFICATION_STATUS = Object.freeze({
  COMPLETED: "completed",
  PASSED: "passed",
  FAILED: "failed",
  EXPIRED: "expired",
  APPROVED: "approved",
  DECLINED: "declined",
  SKIPPED: "skipped",
});

// This constants represents "persona_status" property returned by the API
// it should be renamed in the future to PERSONA_VERIFICATION_STATUS
const PERSONA_STATUS = Object.freeze({
  COMPLETED: "COMPLETED",
  FAILED: "FAILED",
  EXPIRED: "EXPIRED",
  PENDING: "NOT_STARTED",
  IN_PROGRESS: "IN_PROGRESS",
});

export enum PERSONA_VERIFICATION_STATUS_TYPES {
  COMPLETED = "completed",
  FAILED = "failed",
  EXPIRED = "expired",
}

const VERIFICATION_OF_RESIDENCY_STATUS = Object.freeze({
  SUBMITTED: "submitted",
  WAITING: "waiting",
  NOTIFIED: "notified",
  VERIFIED: "verified",
  STARTED: "started",
});

export enum VERIFICATION_OF_RESIDENCY_STATUS_TYPES {
  SUBMITTED = "submitted",
  WAITING = "waiting",
  NOTIFIED = "notified",
  VERIFIED = "verified",
  STARTED = "started",
}

const PERSONA_ID_CLASS = Object.freeze({
  CITIZEN_CERTIFICATE: "cct",
  CONSULAR_ID: "cid",
  DRIVER_LICENSE: "dl",
  HEALTHCARE_INSURANCE_CARD: "hic",
  NATIONAL_ID: "id",
  INTERNAL_PASSPORT: "ipp",
  LONG_TERM_PASS_CARD: "ltpass",
  MILITARY_ID: "mid",
  MY_NUBMER_CARD: "myn",
  NBI_CARD: "nbi",
  NRIC: "nric",
  OFW_ID: "ofw",
  PAN_CARD: "pan",
  POSTAL_ID: "pid",
  PASSPORT: "pp",
  PASSPORT_CARD: "ppc",
  PERMANENT_RESIDENT_CARD: "pr",
  RESIDENCY_PERMIT: "rp",
  SOCIAL_SECURITY_ID: "sss",
  UMID: "umid",
  VOTER_ID: "vid",
  VISA: "visa",
  WORK_PERMIT: "wp",
});

export enum PersonaIdClass {
  CITIZEN_CERTIFICATE = "cct",
  CONSULAR_ID = "cid",
  DRIVER_LICENSE = "dl",
  HEALTHCARE_INSURANCE_CARD = "hic",
  NATIONAL_ID = "id",
  INTERNAL_PASSPORT = "ipp",
  LONG_TERM_PASS_CARD = "ltpass",
  MILITARY_ID = "mid",
  MY_NUBMER_CARD = "myn",
  NBI_CARD = "nbi",
  NRIC = "nric",
  OFW_ID = "ofw",
  PAN_CARD = "pan",
  POSTAL_ID = "pid",
  PASSPORT = "pp",
  PASSPORT_CARD = "ppc",
  PERMANENT_RESIDENT_CARD = "pr",
  RESIDENCY_PERMIT = "rp",
  SOCIAL_SECURITY_ID = "sss",
  UMID = "umid",
  VOTER_ID = "vid",
  VISA = "visa",
  WORK_PERMIT = "wp",
}

// NOTE: goran - Taken over from https://docs.withpersona.com/reference/verifications#government-id-verifications
const PERSONA_ID_CLASS_LABELS = Object.freeze({
  [PERSONA_ID_CLASS.CITIZEN_CERTIFICATE]: "Citizen Certificate",
  [PERSONA_ID_CLASS.CONSULAR_ID]: "Consular ID",
  [PERSONA_ID_CLASS.DRIVER_LICENSE]: "Driver's License",
  [PERSONA_ID_CLASS.HEALTHCARE_INSURANCE_CARD]: "Healthcare Insurance Card",
  [PERSONA_ID_CLASS.NATIONAL_ID]: "National ID",
  [PERSONA_ID_CLASS.INTERNAL_PASSPORT]: "Internal Passport",
  [PERSONA_ID_CLASS.LONG_TERM_PASS_CARD]: "Long-Term Pass Card",
  [PERSONA_ID_CLASS.MILITARY_ID]: "Military ID",
  [PERSONA_ID_CLASS.MY_NUBMER_CARD]: "My Number Card",
  [PERSONA_ID_CLASS.NBI_CARD]: "NBI Card",
  [PERSONA_ID_CLASS.NRIC]: "NRIC",
  [PERSONA_ID_CLASS.OFW_ID]: "OFW ID",
  [PERSONA_ID_CLASS.PAN_CARD]: "PAN card",
  [PERSONA_ID_CLASS.POSTAL_ID]: "Postal ID",
  [PERSONA_ID_CLASS.PASSPORT]: "Passport",
  [PERSONA_ID_CLASS.PASSPORT_CARD]: "Passport Card",
  [PERSONA_ID_CLASS.PERMANENT_RESIDENT_CARD]: "Permanent Resident Card",
  [PERSONA_ID_CLASS.RESIDENCY_PERMIT]: "Residency Permit",
  [PERSONA_ID_CLASS.SOCIAL_SECURITY_ID]: "Social Security ID",
  [PERSONA_ID_CLASS.UMID]: "UMID",
  [PERSONA_ID_CLASS.VOTER_ID]: "Voter ID",
  [PERSONA_ID_CLASS.VISA]: "Visa",
  [PERSONA_ID_CLASS.WORK_PERMIT]: "Work Permit",
});

const PERSONA_FILE_TYPE = Object.freeze({
  DOCUMENT_FRONT_PHOTO: "document_front_photo",
  DOCUMENT_BACK_PHOTO: "document_back_photo",
  SELFIE_LEFT_PHOTO: "selfie_left_photo",
  SELFIE_CENTER_PHOTO: "selfie_center_photo",
  SELFIE_RIGHT_PHOTO: "selfie_right_photo",
});

const PERSONA_FILE_TYPE_LABELS = Object.freeze({
  [PERSONA_FILE_TYPE.DOCUMENT_FRONT_PHOTO]: "Document front photo",
  [PERSONA_FILE_TYPE.DOCUMENT_BACK_PHOTO]: "Document back photo",
  [PERSONA_FILE_TYPE.SELFIE_LEFT_PHOTO]: "Selfie left photo",
  [PERSONA_FILE_TYPE.SELFIE_CENTER_PHOTO]: "Selfie center photo",
  [PERSONA_FILE_TYPE.SELFIE_RIGHT_PHOTO]: "Selfie right photo",
});

const PERSONA_CHECK_STATUS = Object.freeze({
  PASSED: "passed",
  FAILED: "failed",
  NOT_APPLICABLE: "not_applicable",
});

// NOTE: goran - taken over from https://docs.withpersona.com/docs/verification-checks#check-list
/* eslint-disable max-lines */
const PERSONA_CHECKS_REASONS_MAP = Object.freeze({
  // =====================
  // AAMVA CHECKS
  // =====================
  aamva_address_comparison: {
    reasons: {
      aamva_error: "An error occurred accessing the AAMVA database.",
      insufficient_match:
        "The postal code provided did not sufficiently match AAMVA.",
      invalid_issuing_authority:
        "This issuing authority does not provide information to AAMVA.",
    },
    not_applicable: {
      skip_invalid_issuing_authority:
        "This issuing authority does not provide information to AAMVA.",
    },
  },
  aamva_birthdate_comparison: {
    reasons: {
      aamva_error: "An error occurred accessing the AAMVA database.",
      insufficient_match:
        "The birthdate provided did not sufficiently match AAMVA.",
      invalid_issuing_authority:
        "This issuing authority does not provide information to AAMVA.",
    },
    not_applicable: {
      skip_invalid_issuing_authority:
        "This issuing authority does not provide information to AAMVA.",
    },
  },
  aamva_expiration_date_comparison: {
    reasons: {
      aamva_error: "An error occurred accessing the AAMVA database.",
      insufficient_match:
        "The expiration date provided did not sufficiently match AAMVA.",
      invalid_issuing_authority:
        "This issuing authority does not provide information to AAMVA.",
    },
    not_applicable: {
      skip_invalid_issuing_authority:
        "This issuing authority does not provide information to AAMVA.",
      state_not_supported:
        "This issuing authority does not provide this field to AAMVA",
    },
  },
  aamva_identification_number_comparison: {
    reasons: {
      aamva_error: "An error occurred accessing the AAMVA database.",
      insufficient_match:
        "The identification number provided did not sufficiently match AAMVA.",
      invalid_issuing_authority:
        "This issuing authority does not provide information to AAMVA.",
    },
    not_applicable: {
      skip_invalid_issuing_authority:
        "This issuing authority does not provide information to AAMVA.",
    },
  },
  aamva_identity_comparison: {
    reasons: {
      medium_risk:
        "One or more medium risk attributes provided did not sufficiently match AAMVA.",
      high_risk:
        "One or more high risk attributes provided did not sufficiently match AAMVA.",
    },
    not_applicable: {
      missing_issuing_year: "The issuing year was not provided.",
    },
  },
  aamva_issue_date_comparison: {
    reasons: {
      aamva_error: "An error occurred accessing the AAMVA database.",
      insufficient_match:
        "The expiration date provided did not sufficiently match AAMVA.",
      invalid_issuing_authority:
        "This issuing authority does not provide information to AAMVA.",
    },
    not_applicable: {
      skip_invalid_issuing_authority:
        "This issuing authority does not provide information to AAMVA.",
      state_not_supported:
        "This issuing authority does not provide this field to AAMVA",
    },
  },
  aamva_name_comparison: {
    reasons: {
      aamva_error: "An error occurred accessing the AAMVA database.",
      insufficient_match: "The name provided did not sufficiently match AAMVA.",
      invalid_issuing_authority:
        "This issuing authority does not provide information to AAMVA.",
      name_first_insufficient_match: "The first name failed to match AAMVA.",
      name_last_insufficient_match: "The last name failed to match AAMVA.",
    },
    not_applicable: {
      skip_invalid_issuing_authority:
        "This issuing authority does not provide information to AAMVA.",
    },
  },
  aamva_service_available_detection: {
    reasons: {
      external_service_error: "An error occurred accessing the AAMVA service.",
    },
    not_applicable: {},
  },

  // =====================
  // DATABASE CHECKS
  // =====================
  database_address_comparison: {
    reasons: {
      insufficient_match:
        "The address provided did not sufficiently match a record in the authoritative or issuing databases.",
    },
    not_applicable: {
      not_required: "Address comparison was not required.",
      tin_check_passed:
        "Address comparison skipped due to TIN number submission.",
    },
  },
  database_address_deliverable_detection: {
    reasons: {
      missing_secondary_information:
        "Part of the address (e.g. apt number) was missing",
      not_deliverable:
        "The address provided does not appear to be deliverable.",
    },
    not_applicable: {
      not_required: "Address deliverable check was not run.",
    },
  },
  database_address_residential_detection: {
    reasons: {
      commercial_address: "The address provided appears to be commercial.",
      unknown_address_type: "The address type provided is not known.",
    },
    not_applicable: {
      not_required: "Address residential check was not run.",
    },
  },
  database_attribute_comparison: {
    reasons: {
      property_conflict:
        "Database properties are inconsistent with the provided values.",
    },
    not_applicable: {
      missing_properties:
        "Claimed attributes like name or birthdate are missing.",
      unsupported_comparison_language:
        "Claimed or extracted attributes include characters from an unsupported language.",
    },
  },
  database_birthdate_comparison: {
    reasons: {
      insufficient_match:
        "The birthdate provided did not sufficiently match a record in the authoritative or issuing databases.",
    },
    not_applicable: {
      not_required: "Birthdate comparison was not required.",
      tin_check_passed:
        "Birthdate comparison skipped due to TIN number submission.",
    },
  },
  database_deceased_detection: {
    reasons: {
      person_is_deceased:
        "The information provided match the records of a deceased person.",
    },
    not_applicable: {
      not_required: "Deceased records check was not required.",
      unavailable_for_country:
        "The deceased records are unavailable for the country.",
    },
  },
  database_identity_comparison: {
    reasons: {
      property_conflict:
        "Claimed attributes do not match what was found on the identity record.",
      unsupported_country:
        "The selected country is not currently configured for this check.",
    },
  },
  database_inquiry_comparison: {
    reasons: {
      property_conflict:
        "Attributes on the inquiry are inconsistent with what was submitted.",
    },
    not_applicable: {
      missing_properties: "Inquiry details like name or birthdate are missing.",
      no_inquiry: "No associated inquiry.",
      unsupported_comparison_language:
        "Comparison attributes include characters from an unsupported language.",
    },
  },
  database_name_comparison: {
    reasons: {
      insufficient_match:
        "The name provided did not sufficiently match a record in the authoritative or issuing databases.",
    },
    not_applicable: {
      not_required: "Name comparison was not required",
    },
  },
  database_email_address_comparison: {
    reasons: {
      insufficient_match:
        "The email address provided did not sufficiently match a record in the authoritative or issuing databases.",
    },
    not_applicable: {
      not_required: "Email address comparison was not required.",
      tin_check_passed:
        "Email address comparison skipped due to a passed TIN number submission.",
    },
  },
  database_phone_number_comparison: {
    reasons: {
      insufficient_match:
        "The phone number provided did not sufficiently match a record in the authoritative or issuing databases.",
    },
    not_applicable: {
      not_required: "Phone number comparison was not required.",
      tin_check_passed:
        "TIN record matched, but phone number comparison is not configurable for TIN.",
    },
  },
  database_po_box_detection: {
    reasons: {
      address_is_hc_box: "The address is a HC box.",
      address_is_po_box: "The address is a PO box.",
    },
    not_applicable: {
      address_is_non_us_territory: "The address is a non US territory.",
      missing_address: "No address was submitted.",
    },
  },
  database_social_security_number_comparison: {
    reasons: {
      insufficient_match:
        "The identification number provided did not sufficiently match a record in the authoritative or issuing databases.",
    },
    not_applicable: {
      not_required: "identification number comparison was not required.",
    },
  },
  database_two_plus_two_detection: {
    reasons: {
      insufficient_match:
        "The identity provided did not sufficiently match a record in the authoritative or issuing databases.",
    },
    not_applicable: {
      not_required: "2+2 detection was not required.",
    },
  },

  // =====================
  // DOCUMENT CHECKS
  // =====================
  document_compromised_detection: {
    reasons: {
      publicly_available:
        "The submission exists in publicly available sources.",
    },
  },
  document_expired_detection: {
    reasons: {
      expired: "Document has expired.",
    },
  },
  document_fabrication_detection: {
    reasons: {
      fabricated: "Document is fabricated.",
    },
  },
  document_portrait_detection: {
    reasons: {
      portrait_not_found: "The submission is missing a face.",
    },
  },
  document_tamper_detection: {
    reasons: {
      exif_inconsistency:
        "The submission has inconsistencies in the file metadata that imply image tampering.",
      image_manipulated:
        "The submission appears to have been digitally tampered.",
    },
  },
  document_extracted_properties_detection: {
    reasons: {
      match_rejected: "Match was rejected for a pattern.",
      match_missing: "The submission is missing a match pattern.",
    },
  },
  document_recency_detection: {
    reasons: {
      no_issue_date: "The submission is missing an issue date.",
      not_recent: "Document is not recent enough.",
    },
  },
  document_selfie_comparison: {
    reasons: {
      face_mismatch:
        "The face portrait on the document and the selfie appear to be different faces.",
    },
  },
  document_type_detection: {
    reasons: {
      type_mismatch: "The submission is not one of the expected types.",
    },
  },
  document_unprocessable_submission_detection: {
    reasons: {
      unprocessable:
        "The submission is not processable. (e.g. malformed document)",
    },
  },
  document_pdf_modification_detection: {
    reasons: {
      modified_pdf_structure:
        "The internal PDF structure suggests that the PDF has been modified after creation.",
      inconsistent_timestamps:
        "The creation date and modification date of the PDF are different.",
    },
  },
  document_handwriting_detection: {
    reasons: {
      handwriting_detected: "Handwriting was detected.",
      signature_detected: "Signature was detected.",
    },
  },

  // =====================
  // GOVERNMENT ID CHECKS
  // =====================
  id_account_comparison: {
    reasons: {
      face_mismatch:
        "Face is inconsistent with the selfie found on the account.",
      property_conflict:
        "ID properties are inconsistent with the account details.",
    },
    not_applicable: {
      missing_properties: "Missing properties for account comparison.",
      no_account: "No account associated with this verification.",
      unsupported_comparison_language:
        "Comparison attributes include characters from an unsupported language.",
    },
  },
  id_age_comparison: {
    reasons: {
      failed_requirement: "ID details do not meet age requirements.",
    },
    not_applicable: {
      missing_birthdate: "The birthdate is missing.",
      no_configuration:
        "The verification does not have an age comparison configuration.",
    },
  },
  id_age_inconsistency_detection: {
    reasons: {
      inconsistent_age:
        "The age listed on the ID appears to be different than the age estimated from the face portrait.",
    },
    not_applicable: {
      missing_age_range: "The age range is missing.",
      missing_birthdate: "The birth date is missing.",
      missing_face: "The ID has no face.",
      missing_issuing_date: "The issue date is missing.",
    },
  },
  id_attribute_comparison: {
    reasons: {
      property_conflict:
        "ID properties are inconsistent with the provided values.",
    },
    not_applicable: {
      missing_properties:
        "Claimed attributes like name or birthdate are missing.",
      unsupported_comparison_language:
        "Claimed or extracted attributes include characters from an unsupported language.",
    },
  },
  id_barcode_detection: {
    reasons: {
      back_missing: "Unsuccessful detection of the back of the ID.",
      barcode_not_decoded: "The barcode on the ID cannot be decoded.",
      barcode_not_detected: "The barcode on the ID is not found.",
    },
    not_applicable: {
      barcode_not_required: "The barcode was not collected.",
      unsupported_country:
        "This check is not currently supported for this country.",
    },
  },
  id_barcode_inconsistency_detection: {
    reasons: {
      field_invalid: "The barcode has fields in invalid formats.",
      format_invalid: "The barcode does not follow ID specifications.",
      issuer_invalid: "The barcode specifies an issuer that is invalid.",
      issuer_mismatch: "The barcode has inconsistent issuer information.",
      metadata_invalid:
        "Barcode metadata is inconsistent with genuine IDs from the provided issuer.",
      required_field_missing: "The barcode is missing required fields.",
      revision_invalid:
        "Barcode revision is inconsistent with genuine IDs from the provided issuer.",
    },
    not_applicable: {
      back_missing: "Unsuccessful detection of the back of the ID.",
      barcode_not_decoded: "The barcode on the ID cannot be decoded.",
      barcode_not_detected: "The barcode on the ID is not found.",
      unsupported_country:
        "This check is not currently supported for this country.",
    },
  },
  id_color_inconsistency_detection: {
    reasons: {
      image_is_monochrome:
        "The colors detected on the ID appear to be monochromatic.",
    },
  },
  id_compromised_detection: {
    reasons: {
      fraudulent: "The ID is reported as fraudulent.",
      publicly_available: "The ID is likely a sample ID or publicly available.",
      sample_document: "The ID contains a word that indicates it is a sample.",
    },
  },
  id_corner_detection: {
    reasons: {
      insufficient_padding: "The ID is too close to the edge of the image.",
    },
    not_applicable: {
      unidentified: "The ID could not be identified.",
      unsupported_country: "The country is not supported by this check.",
      unsupported_document_type:
        "The type of ID is not supported by this check.",
    },
  },
  id_damaged_detection: {
    reasons: {
      holepunch_detected: "A holepunch was detected on the ID.",
    },
  },
  id_disallowed_country_detection: {
    reasons: {
      no_country: "No country was extracted.",
      not_allowed_by_configuration:
        "The country of the ID is not allowed based on template requirements.",
      selected_country_mismatch:
        "The country of the ID does not match the country selected by the user.",
    },
    not_applicable: {
      no_country_configuration: "All countries are allowed.",
    },
  },
  id_disallowed_type_detection: {
    reasons: {
      disallowed_designation:
        "The ID has a designation that is not allowed based on template requirements.",
      not_allowed_by_configuration:
        "The ID type is not allowed based on template requirements.",
      restricted_type:
        "The ID type cannot be collected due to federal compliance requirements.",
      type_mismatch:
        "The ID type detected does not match the ID type the user selected.",
      type_not_detected:
        "The ID type of the submission could not be identified.",
    },
    not_applicable: {
      unrestricted: "There are no restrictions on ID type.",
    },
  },
  id_double_side_detection: {
    reasons: {
      side_submitted_twice:
        "The back and front submissions of the ID are of the same side.",
    },
    not_applicable: {
      single_sided: "The provided ID is expected to only have one side",
    },
  },
  id_electronic_replica_detection: {
    reasons: {
      digital_text_found:
        "The submission may contain digital text which is often found on a replica.",
      emulator_detected:
        "The submission may have been submitted on an emulator.",
      photocopy_found: "The submission may be a replica of a photocopy.",
      replica_detected: "The submission may be a generic replica.",
      rooted_device:
        "The submission may have been submitted on a rooted device.",
      screenshot_found: "The submission may be a replica of a screenshot.",
      virtual_camera_detected:
        "The submission may have been submitted using a virtual camera.",
    },
  },
  id_entity_detection: {
    reasons: {
      cannot_verify_id:
        "This submission does not appear to include a government ID.",
    },
  },
  id_expired_detection: {
    reasons: {
      expired: "The ID is expired.",
    },
    not_applicable: {
      no_expiration_date: "The expiration date is missing.",
    },
  },
  id_extracted_properties_detection: {
    reasons: {
      required_properties_absent_on_id:
        "The missing required properties are not present on the ID.",
      property_not_extracted: "Required ID field(s) were not extracted.",
      name_partially_extracted:
        "First name and last name were required, but only one was extracted.",
    },
    not_applicable: {
      no_required_properties:
        "The template is not configured to require extraction of certain properties.",
    },
  },
  id_extraction_inconsistency_detection: {
    reasons: {
      property_mismatch:
        "Details extracted from the front of the ID are different than the details extracted from the barcode.",
    },
    not_applicable: {
      back_missing: "Unsuccessful detection of the back of the ID.",
      missing_properties: "Barcode is missing properties to compare.",
      unsupported_country:
        "This check is not currently supported for this country.",
    },
  },
  id_fabrication_detection: {
    reasons: {
      fabricated_id_version:
        "The submitted ID does not match a known in-circulation format of that ID type.",
      camouflage_passport:
        "The submitted ID is issued by an unrecognized or invalid government entity.",
    },
  },
  id_glare_detection: {
    reasons: {
      too_much_glare: "The submission has glare.",
    },
  },
  id_inconsistent_repeat_detection: {
    reasons: {
      inconsistent_details:
        "The face portrait matches that of a previously submitted ID with different details.",
      inconsistent_face:
        "The ID details matches that of a previously submitted ID with a different face portrait.",
    },
    not_applicable: {
      low_quality_portrait: "Portrait quality is too low for comparison.",
      no_portrait: "The face portrait is missing.",
      not_enabled: "Inconsistent repeat is not enabled.",
    },
  },
  id_inquiry_comparison: {
    reasons: {
      names_swapped:
        "The claimed first name matches the extracted last name and vice versa.",
      property_conflict:
        "ID details like name or birthdate are inconsistent between different submission attempts.",
    },
    not_applicable: {
      missing_properties: "Inquiry details like name or birthdate are missing.",
      no_inquiry: "No associated inquiry.",
      unsupported_comparison_language:
        "Comparison attributes include characters from an unsupported language.",
    },
  },
  id_mrz_detection: {
    reasons: {
      mrz_incomplete:
        "The full area of the encoded, machine-readable text on the ID was not detected.",
      mrz_not_found:
        "The encoded, machine-readable text on the ID is not found.",
    },
  },
  id_mrz_inconsistency_detection: {
    reasons: {
      mrz_checksum_invalid:
        "The encoded, machine-readable text on the ID has invalid checksum(s).",
    },
    not_applicable: {
      mrz_not_found:
        "The encoded, machine-readable text on the ID is not found.",
      mrz_not_verifiable:
        "The encoded, machine-readable text on the ID is present but not verifiable (e.g. because it may be partially obscured).",
    },
  },
  id_number_format_inconsistency_detection: {
    reasons: {
      incorrect_format: "The ID number has an invalid format.",
      invalid_checksum: "The ID number has an invalid checksum.",
      invalid_encoded_data:
        "Data encoded in the ID number does not match data extracted from the ID.",
    },
    not_applicable: {
      unsupported_country:
        "This check is not currently supported for this country.",
    },
  },
  id_paper_detection: {
    reasons: {
      paper_id_detected: "The submitted ID is printed on a piece of paper.",
    },
    not_applicable: {
      expected_paper_id_type:
        "The submitted ID type matches a known paper ID type.",
    },
  },
  id_physical_tamper_detection: {
    reasons: {
      tamper_detected:
        "The submission appears to have been tampered physically.",
    },
  },
  id_po_box_detection: {
    reasons: {
      address_is_hc_box: "The address is a HC box.",
      address_is_po_box: "The address is a PO box.",
    },
    not_applicable: {
      missing_address: "No address was submitted.",
    },
  },
  id_portrait_clarity_detection: {
    reasons: {
      portrait_not_clear: "The face portrait is unclear and out of focus.",
    },
  },
  id_portrait_detection: {
    reasons: {
      portrait_not_found: "The submission has no face portrait.",
    },
  },
  id_public_figure_detection: {
    reasons: {
      public_figure_detected:
        "The face portrait appears to match that of a known public figure.",
    },
    not_applicable: {
      low_quality_portrait: "Portrait quality is too low for comparison.",
      missing_face: "The ID has no face.",
    },
  },
  id_real_id_detection: {
    reasons: {
      federal_limits_apply:
        "ID does not meet federal guidelines for REAL Enhanced IDs.",
      federal_limits_undetected: "ID's compliance type could not be detected.",
    },
    not_applicable: {
      invalid_barcode: "Barcode on ID could not be read.",
      invalid_country: "REAL ID is not available for the given country.",
      invalid_id_type: "ID type is not supported by REAL ID.",
      no_barcode: "ID's barcode was not provided.",
    },
  },
  id_repeat_detection: {
    reasons: {
      repeat:
        "The ID details and face portrait match that of a previously submitted ID on a different account.",
      details_only_repeat:
        "The ID details match that of a previously submitted ID on a different account.",
    },
    not_applicable: {
      not_enabled: "ID repeat detection is not enabled.",
    },
  },
  id_selfie_comparison: {
    reasons: {
      face_mismatch:
        "The selfie and the face portrait in the ID appear to be different faces.",
    },
    not_applicable: {
      no_selfie: "The submission has no selfie.",
    },
  },
  id_tamper_detection: {
    reasons: {
      portrait_tampering: "The submission appears to have a tampered portrait.",
      exif_inconsistency:
        "The submission has inconsistencies in the file metadata.",
      image_manipulated:
        "The submission appears to have been tampered by an editor.",
    },
  },
  id_unprocessable_submission_detection: {
    reasons: {
      age_below_limit:
        "The age detected in the portrait is below the processable age limit.",
      submission_invalid: "The submission is unprocessable.",
    },
  },
  id_valid_dates_detection: {
    reasons: {
      issuer_rules_inconsistency:
        "The dates on the ID appear to be in violation of issuing authority rules.",
    },
    not_applicable: {
      unknown_date_rules:
        "The ID is temporary or limited-term, so the valid date rules are unknown",
    },
  },
  id_video_quality_detection: {
    reasons: {
      corrupt: "The video is corrupt.",
      low_bit_rate: "The bit rate is too low.",
      low_frame_rate: "The frame rate is too low.",
      not_found: "There was no video uploaded.",
      duration_too_short: "The duration of the video was too short.",
    },
  },

  // =====================
  // SELFIE CHECKS
  // =====================
  selfie_account_comparison: {
    reasons: {
      face_mismatch:
        "The selfie is inconsistent with the portrait on the account.",
    },
    not_applicable: {
      missing_face: "The selfie has no face.",
      no_account_selfie_present: "The account has no selfie.",
    },
  },
  selfie_age_comparison: {
    reasons: {
      age_above_limit:
        "The age range detected in the selfie is above the age limit.",
      age_below_limit:
        "The age range detected in the selfie is below the age limit.",
      age_mismatch:
        "The reference age falls outside of the age range detected in the selfie.",
    },
    not_applicable: {
      no_reference_birthdate: "No reference birthdate was provided.",
      no_selfie_age: "No perceived age was available from the selfie.",
      no_selfie_age_estimation:
        "No perceived age estimation was available from the selfie.",
    },
  },
  selfie_age_threshold_comparison: {
    reasons: {
      age_outside_limits:
        "The age range detected in the selfie falls outside of configured age limits.",
      no_selfie_age_prediction:
        "No perceived age prediction was available from the selfie.",
    },
    not_applicable: {
      no_age_limits: "No min or max age limit was configured.",
    },
  },
  selfie_attribute_comparison: {
    reasons: {
      face_mismatch: "The selfie is inconsistent with the provided selfies.",
    },
    not_applicable: {
      no_comparison_inputs: "No selfies were provided for comparison.",
      no_selfie: "The submission has no selfie.",
    },
  },
  selfie_face_covering_detection: {
    reasons: {
      face_covering_detected:
        "The selfie contains a person with a PPE face covering.",
    },
  },
  selfie_glasses_detection: {
    reasons: {
      glasses:
        "Glasses are detected and may interfere with selfie face detection.",
      sunglasses:
        "Sunglasses are detected and may interfere with selfie face detection.",
    },
  },
  selfie_id_comparison: {
    reasons: {
      comparison_attempt_unsuccessful:
        "An error has occurred that made the selfie and government ID comparison attempt fail.",
      face_mismatch:
        "The selfie and the face portrait in the ID appear to be different faces.",
    },
    not_applicable: {
      no_government_id: "Inquiry has no ID portrait.",
      no_selfie: "Inquiry has no selfie.",
    },
  },
  selfie_image_quality_detection: {
    reasons: {
      insufficient_detail: "Camera resolution or image detail is too low.",
      insufficient_illumination: "The submission has insufficient lighting.",
      excessive_illumination: "The submission is too excessively lit.",
    },
  },
  selfie_liveness_detection: {
    reasons: {
      deepfake_detected: "The selfie appears to be a deepfake.",
      device_detected: "The selfie does not appear to be a live person.",
      emulator_detected:
        "The submission may have been submitted on an emulator.",
      gen_ai_detected: "The selfie appears to be an AI generated image.",
      invalid_pose:
        "Failed to determine selfie liveness due to inadequate image quality.",
      replica_2d_detected: "The selfie appears to be a 2d replica.",
      replica_detected:
        "The selfie has characteristics that are indicative of a spoof.",
      rooted_device: "The images may have been submitted on a rooted device.",
      unexpected_orientation: "The submission is not properly oriented.",
      virtual_camera_detected:
        "The selfie has characteristics that are indicative of virtual camera usage.",
    },
    not_applicable: {
      not_enabled: "Not enabled.",
    },
  },
  selfie_multiple_faces_detection: {
    reasons: {
      face_conflict: "The selfies appear to be different faces across poses.",
      multiple_faces_detected: "The selfies has multiple faces in the frame.",
    },
    not_applicable: {
      center_only: "The selfie has only one pose.",
    },
  },
  selfie_portrait_quality_detection: {
    reasons: {
      eyes_closed: "The face portrait appears to have closed eyes.",
      missing_face: "The selfie has no face.",
      portrait_not_clear: "The face portrait is unclear and out of focus.",
    },
  },
  selfie_pose_detection: {
    reasons: {
      center_pose_face_obscured: "The center selfie's face appears obscured.",
      face_cropped: "The selfie does not capture the entire face.",
      face_quality: "The selfie captured is unclear and out of focus",
      face_too_far: "The selfie captured was too small.",
      missing_yaw_angles: "Missing yaw angles.",
      pose_order_incorrect: "The submitted pose order was incorrect",
      required_poses_not_found:
        "The selfies appear to be incorrectly positioned in one or more poses.",
    },
    not_applicable: {
      center_only: "The selfie has only one pose.",
    },
  },
  selfie_pose_repeat_detection: {
    reasons: {
      poses_repeated: "The selfies appear to repeat across poses.",
    },
    not_applicable: {
      center_only: "The selfie has only one pose.",
    },
  },
  selfie_public_figure_detection: {
    reasons: {
      public_figure:
        "The selfie submission appears to be of a known public figure.",
    },
    not_applicable: {
      image_quality_low: "Image quality is too low for repeat detection.",
      missing_face: "The selfie has no face.",
    },
  },
  selfie_repeat_detection: {
    reasons: {
      repeat_image:
        "The image matches that of a previously submitted selfie on a different account.",
      repeat:
        "The selfie matches that of a previously submitted selfie on a different account.",
    },
    not_applicable: {
      image_quality_low: "Image quality is too low for repeat detection.",
      not_enabled: "Selfie repeat detection is not enabled.",
    },
  },
  selfie_suspicious_entity_detection: {
    reasons: {
      suspicious_photo: "The selfie submission appears to be a government ID.",
    },
  },
  selfie_video_quality_detection: {
    reasons: {
      corrupt: "The video is corrupt.",
      duration_too_short: "The duration of the video was too short.",
      low_bit_rate: "The bit rate is too low.",
      low_frame_rate: "The frame rate is too low.",
      not_found: "There was no video uploaded.",
    },
  },
});

export {
  INTEGRATION_TYPES,
  PERSONA_CHECKS_REASONS_MAP,
  PERSONA_CHECK_STATUS,
  PERSONA_FILE_TYPE,
  PERSONA_FILE_TYPE_LABELS,
  PERSONA_ID_CLASS,
  PERSONA_ID_CLASS_LABELS,
  PERSONA_STATUS,
  PERSONA_VERIFICATION_STATUS,
  PERSONA_VERIFICATION_TYPES,
  PERSONA_VERIFICATION_TYPES_LABELS,
  PERSONA_VERIFICATION_PREFIXES,
  VERIFICATION_OF_RESIDENCY_STATUS,
  YARDI_SECURITY_DEPOSIT_PREFERENCES,
};
